
<app-dyn-form #dynForm key="applicant-statuses" [model]="model" [showTitle]="false" [isEditMode]="true"
    [autoSave]="true" (result)="onSubmit($event)" (valueChanged)="onChange()">
</app-dyn-form>
<mat-spinner *ngIf="isLoading" [diameter]="30" color="primary"></mat-spinner>
